// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "extras-d6T3u";
var _4 = "wrapper-1Pq9_";
export { _1 as "__esModule", _2 as "mobile", _3 as "extras", _4 as "wrapper" }
export default { "__esModule": _1, "mobile": _2, "extras": _3, "wrapper": _4 }
